import { render, staticRenderFns } from "./ModalFavoritesAlert.vue?vue&type=template&id=284a07bc&scoped=true&"
import script from "./ModalFavoritesAlert.vue?vue&type=script&lang=ts&"
export * from "./ModalFavoritesAlert.vue?vue&type=script&lang=ts&"
import style0 from "./ModalFavoritesAlert.vue?vue&type=style&index=0&id=284a07bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a07bc",
  null
  
)

export default component.exports